<div class="row">
    <div class="col-md-6">
        <div class="widget right-ear">
            <div *ngIf="viewModel?.rightSession" class="row h-100">
                <div class="col-md-5">
                    <div class="title">
                        {{'Screens.Patients.InfoWidget.NoahSession.RightEar' | translate}}
                    </div>
                    <div class="details-info">
                        {{ viewModel.rightSession.name }}
                        <br />
                    </div>
                </div>
                <div class="col-md-7">
                    <noah-graph *ngIf="!missingRightData" [graphModel]="viewModel?.rightSession?.graph" [side]="1"></noah-graph>
                    <div *ngIf="missingRightData" class="no-data-message">
                        {{'Screens.Patients.InfoWidget.NoahSession.NoDataMessage' | translate}}
                    </div>
                </div>
            </div>
            <span *ngIf="viewModel?.rightSession?.sessionDate" class="tested-date">
                {{'Screens.Patients.InfoWidget.NoahSession.SessionDate' | translate}}:
                {{viewModel.rightSession.sessionDate | wafShortDate}}
            </span>
            <div *ngIf="!viewModel?.rightSession" class="no-data-message">
                {{'Screens.Patients.InfoWidget.NoahSession.NoDataMessage' | translate}}
            </div>
        </div>
    </div>
    <div class="col-md-6">
        <div class="widget left-ear">
            <div class="row h-100" *ngIf="viewModel?.leftSession">
                <div class="col-md-5">
                    <div class="title">
                        {{'Screens.Patients.InfoWidget.NoahSession.LeftEar' | translate}}
                    </div>
                    <div class="details-info">
                        {{ viewModel.leftSession.name }}
                        <br />
                    </div>
                </div>
                <div class="col-md-7">
                    <noah-graph *ngIf="!missingLeftData" [graphModel]="viewModel?.leftSession?.graph" [side]="2"></noah-graph>
                    <div *ngIf="missingLeftData" class="no-data-message">
                        {{'Screens.Patients.InfoWidget.NoahSession.NoDataMessage' | translate}}
                    </div>
                </div>
            </div>
            <span *ngIf="viewModel?.leftSession?.sessionDate" class="tested-date">
                {{'Screens.Patients.InfoWidget.NoahSession.SessionDate' | translate}}:
                {{viewModel.leftSession.sessionDate | wafShortDate}}
            </span>
            <div *ngIf="!viewModel?.leftSession" class="no-data-message">
                {{'Screens.Patients.InfoWidget.NoahSession.NoDataMessage' | translate}}
            </div>
        </div>
    </div>
</div>
